import React from "react";
import ButtonCell from "../buttons/ButtonCell";
import { RuleModuleType } from "../../constants/constants";
import { RulesContext } from "../../contexts/RulesContext";
import FormWithNameAndKey from "./FormWithNameAndKey";
import TextInputCell from "../gridCells/TextInputCell";

interface Props {
  section_i: number;
}

export default ({ section_i }: Props) => {
  const { addRuleModuleAndRefresh } = React.useContext(RulesContext);
  const [started, setStarted] = React.useState(false);
  const [typeChosen, setTypeChosen] = React.useState(
    RuleModuleType.RankAndSource
  );
  const [ruleItemName, setRuleItemName] = React.useState("");
  const [name, setName] = React.useState("");
  const [key, setKey] = React.useState("");

  const selectModuleType = (event: any) => {
    setTypeChosen(event.target.value);
  };

  const resetState = (start: boolean) => {
    setTypeChosen(RuleModuleType.RankAndSource);
    setRuleItemName("");
    setName("");
    setKey("");
    setStarted(start);
  };

  const addModuleAndReset = () => {
    addRuleModuleAndRefresh(section_i, {
      moduleName: name,
      ruleItemName: ruleItemName,
      key: key,
      moduleType: typeChosen,
      list: [],
      config: {
        min: 0,
        max: 10,
        default: 0,
        selectOptions: { name, key },
      },
    });
    setStarted(false);
  };

  const availableModuleTypes = Object.values(RuleModuleType).map(
    (item: string, i: number) => {
      return (
        <option value={item} key={i + "_" + item}>
          {item}
        </option>
      );
    }
  );
  return (
    <>
      <FormWithNameAndKey
        started={started}
        dataTest={`add-module-form-${section_i}`}
        typeName={`Rules Module`}
        resetState={resetState}
        setItemName={setName}
        setItemKey={setKey}
      >
        <TextInputCell
          dataTest={`module-name-input-${section_i}`}
          placeholder={`Item Name`}
          onChange={(event: any) => setRuleItemName(event.target.value)}
          value={ruleItemName}
        />
        <select
          data-test={`module-type-select-${section_i}`}
          className="textCell inline-select inline-select-background"
          value={typeChosen}
          onChange={selectModuleType}
        >
          {availableModuleTypes}
        </select>
        <ButtonCell
          buttonText="Add"
          classes="cancel-edit"
          dataTest={`module-add-${section_i}`}
          onClick={addModuleAndReset}
        />
      </FormWithNameAndKey>
    </>
  );
};
